import {Column} from 'react-table'
import {IndemnityAreaActionsCell} from './IndemnityAreaActionsCell'
import {IndemnityAreaCustomHeader} from './IndemnityAreaCustomHeader'
import {IndemnityArea} from '../../core/_models'
import {IndemnityAreaItem} from './IndemnityAreaItem'
import {IndemnityAreaQuant} from './IndemnityAreaQuant'
import {IndemnityAreaAnnualServitudeValue} from './IndemnityAreaAnnualServitudeValue'
import {IndemnityAreaSingleServitudeValue} from './IndemnityAreaSingleServitudeValue'
import {IndemnityAreaBusinessInterruptionValue} from './IndemnityAreaBusinessInterruptionValue'
import {IndemnityAreaDirectDamageValue} from './IndemnityAreaDirectDamageValue'

const IndemnityItemsColumns: ReadonlyArray<Column<IndemnityArea>> = [
  //HEADER COLUMN - PROJECT
  {
    Header: (props) => (
      <IndemnityAreaCustomHeader
        tableProps={props}
        title='COMMON.INPUT_NAME'
        className='fs-9 min-w-75px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'name',
    Cell: ({...props}) => <IndemnityAreaItem IndemnityArea={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <IndemnityAreaCustomHeader
        tableProps={props}
        title='INDEMNITY_ITEM_AREA.QUANTITY'
        className='fs-9 min-w-75px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'quant',
    Cell: ({...props}) => <IndemnityAreaQuant IndemnityArea={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - Conditioning TYPE
  {
    Header: (props) => (
      <IndemnityAreaCustomHeader
        tableProps={props}
        title='INDEMNITY_ITEM_AREA.ANNUAL_SERVITUDE'
        className='fs-9 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'annual_servitude',
    Cell: ({...props}) => (
      <IndemnityAreaAnnualServitudeValue IndemnityArea={props.data[props.row.index]} />
    ),
  },

  //HEADER COLUMN - ENTREPRENEUR
  {
    Header: (props) => (
      <IndemnityAreaCustomHeader
        tableProps={props}
        title='INDEMNITY_ITEM_AREA.SINGLE_SERVITUDE'
        className='fs-9 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'IndemnityAreaSingleServitudeValue',
    Cell: ({...props}) => (
      <IndemnityAreaSingleServitudeValue IndemnityArea={props.data[props.row.index]} />
    ),
  },

  //HEADER COLUMN -  Status ***
  {
    Header: (props) => (
      <IndemnityAreaCustomHeader
        tableProps={props}
        title='INDEMNITY_ITEM_AREA.BUSINESS_INTERRUPTION'
        className='fs-9 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'businessInterruptionValue',
    Cell: ({...props}) => (
      <IndemnityAreaBusinessInterruptionValue IndemnityArea={props.data[props.row.index]} />
    ),
  },

  //HEADER COLUMN - ISSUE DATE ***
  {
    Header: (props) => (
      <IndemnityAreaCustomHeader
        tableProps={props}
        title='INDEMNITY_ITEM_AREA.DIRECT_DAMAGE'
        className='fs-9 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'direct_damage',
    Cell: ({...props}) => (
      <IndemnityAreaDirectDamageValue IndemnityArea={props.data[props.row.index]} />
    ),
  },

  //HEADER COLUMN - ACTIONS
  {
    Header: (props) => (
      <IndemnityAreaCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='fs-9 min-w-50px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => <IndemnityAreaActionsCell IndemnityArea={props.data[props.row.index]} />,
  },
]

export {IndemnityItemsColumns}
